import getUrlForEnv, {services} from "@irati/utils/endpoints/getUrlForEnv"

const endpoints = {
  selfSignup: (id: string) => getUrlForEnv(services.SELF_SIGNUP_SERVICE, `/v1/signup/${id}`),
  selfSignups: () => getUrlForEnv(services.SELF_SIGNUP_SERVICE, "/v1/signup"),

  selfSignupForTenant: (tenantId: string) => getUrlForEnv(services.SELF_SIGNUP_SERVICE, `/v1/signup/tenant/${tenantId}`)
}

export default endpoints
